/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelLeaveTransaction.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/leave-transaction";

export class AutogenModelLeaveTransaction<RowType extends ModelRow> extends Endpoint<RowType, RowLeaveTransactionFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowLeaveTransaction extends ModelRow<RowLeaveTransactionFields> {
	constructor(values?: Partial<RowLeaveTransactionFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowLeaveTransactionFields {
	adjust_id: number;
	amount: number;
	applies_to: string;
	batch_code: string;
	batch_number: number;
	check_date: Date;
	check_number: string;
	company_id: string;
	effect: string;
	id: number;
	is_processed: string;
	is_void: string;
	memo: string;
	payee_id: string;
	post_key: string;
	post_module: string;
	trx_date: Date;
}

